import React from 'react';

const ErrorIcon = ({ color = 'red', width = '16', height = '16' }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="8" cy="8" r="7" stroke={color} strokeWidth="1.5" />
      <rect x="7.25" y="4" width="1.5" height="5" rx="0.75" fill={color} />
      <circle cx="8" cy="11.5" r="1" fill={color} />
    </svg>
  );
};

export default ErrorIcon;
